@import (reference) '../../../../../../constants/spacing.module.less';

.quantity-text {
  font-weight: 500;
  padding: @space-0 @space-4;
}

.is-multiple {
  color: var(--light--text-color--1);
  background: var(--default--background-color--16);

  border-radius: 24px;
  padding: 6px @space-12;
}

.highlight(@background-color, @border-color) {
  background-color: @background-color;
  border: 1px solid @border-color;

  border-radius: 2px;
  padding: @space-4;
}
